import { ChangeDetectionStrategy, Component, inject, input, OnInit, viewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ForecastService } from '../services/forecast.service';
import { capitalByWellGridOptions } from './capitalByWellGridOptions';

@Component({
  selector: 'app-forecast-scenario-detail',
  templateUrl: './forecast-scenario-detail.component.html',
  styleUrls: ['./forecast-scenario-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AgGridAngular,
  ],
})
export class ForecastScenarioDetailComponent implements OnInit {
  private service = inject(ForecastService);

  private readonly agGrid = viewChild(AgGridAngular);

  public capitalByWellGridOptions = capitalByWellGridOptions;

  readonly ScenarioId = input<number | null>(undefined);
  readonly ParentBuildId = input<string | null>(undefined);

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    const scenarioId = this.ScenarioId();
    if (scenarioId == null) return;

    const parentBuildId = this.ParentBuildId();
    if (parentBuildId != null) {
      this.service.getHistoricalCapitalForecastsByWell(scenarioId, parentBuildId).subscribe(x => {
        this.agGrid()?.api?.setGridOption('rowData', x);
      });
    }
    else {
      this.service.getCapitalForecastsByWell(scenarioId).subscribe(x => {
        this.agGrid()?.api?.setGridOption('rowData', x);
      });
    }
  }
}